(function () {
  angular.module('binky.core.price', [
    'binky.core.dom-utils',
    'binky.core.lodash',
    'binky.core.number-format-js',
    'binky.core.src2-migration',
  ]);
})();
